module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Olly Jarvis\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_c('B', [_vm._v("Olly Jarvis")]), _vm._v(" is a writer and criminal defence barrister, originally from London but now working in Manchester. Drawing on his experiences, he writes both fiction and non-fiction with a particular understanding of the pressures and excitement of life in the courtroom. He wrote the highly acclaimed Radio 4 drama Judgement, and wrote and presented the BBC documentary "), _c('I', [_vm._v("Mum Knows Best")]), _vm._v(". He is also the author of "), _c('I', [_vm._v("Death by Dangerous")]), _vm._v(". Olly has two children and lives in Cheshire.")], 1)], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/AXL3jx/tc-custom/9781911420095.jpg?1718282658652",
      "alt": "This image is the cover for the book Cut-Throat Defence, A Jack Kowalski Thriller"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Cut-Throat Defence, A Jack Kowalski Thriller\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("In this “tautly-written” legal thriller, a British defense lawyer’s search for his missing client draws him into Manchester’s criminal underworld ("), _c('i', [_vm._v("Manchester Evening News")]), _vm._v(").")])]), _c('p', [_vm._v(" As the son of Polish immigrants, Jack Kowalski knows how it feels to be the underdog. But now, as a successful young barrister, he’s working on the biggest drugs trials in British history. Determined to prove himself and fight for his clients, he argues a savage “cut-throat: defense—a risky tactic where the defendants blame each other. ")]), _c('p', [_vm._v(" But when his defendant suddenly disappears, Jack and solicitor Lara Panassai struggle to hold the case together. In search of their client, and desperate for new evidence, they must comb through Manchester’s notoriously dangerous underworld. And as each turn takes the case into darker territory, Jack must decide who—if anyone—can be trusted. ")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Canelo Books\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0